import { render, staticRenderFns } from "./GeoTag.vue?vue&type=template&id=a482c062&"
import script from "./GeoTag.vue?vue&type=script&lang=js&"
export * from "./GeoTag.vue?vue&type=script&lang=js&"
import style0 from "./GeoTag.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports